import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import { filterBy } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import { Label } from "@progress/kendo-react-labels";
import * as api from "../../api/index";
import { AmountFormatCell, DateFormatCell } from "components/common/formatter";
import { useState, useEffect } from "react";
import SearchComboBox from "components/common/SearchComboBox";
import CONSTANT from "CONSTANT/Matter/ComboxType";
import { NameTextCell } from "components/common/GridComponents";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useActiveVats } from "services/vatService";
import { useActiveFeeEarner } from "services/userService";

// Reusable Validated ComboBox Component
const ValidatedComboBox = ({ 
  label, 
  value, 
  isRequired = true, 
  showValidation, 
  textField,
  ...comboBoxProps 
}) => {
  // Custom validation logic for different field types
  const getValidationValue = () => {
    if (textField === "representation") {
      // For nominal ref, check if value has nominalRef property
      return value?.nominalRef;
    }
    // For simple values like vatvalue
    return value;
  };
  
  const hasError = showValidation && isRequired && !getValidationValue();
  
  return (
    <div className="d-flex flex-column mb-3 me-3" style={{ width: "300px" }}>
      <Label>{label}</Label>
      <ComboBox
        {...comboBoxProps}
        textField={textField}
        style={{ 
          width: "300px",
          border: hasError ? "1px solid red" : "",
          borderRadius: "4px",
          ...comboBoxProps.style
        }}
        className="mt-1"
        value={value}
      />
    </div>
  );
};

const MattersTimeRecords = (props) => {
  const dispatch = useDispatch();
  const [dataAvailable, setDataAvailable] = useState(false);
  const [error, setError] = useState(undefined);
  const [error1, setError1] = useState(undefined);
  const [nominal, setnominal] = useState();
  const [nominaldata, setnominaldata] = React.useState();
  const [data, setData] = React.useState([]);
  const [initialData, setInitialData] = useState();
  const [matters, setMatters] = useState([]);

  const [vatvalue, setvatvalue] = useState();
  const [vatsdata, setvatsData] = React.useState();
  const [showValidation, setShowValidation] = useState(false);

  const { data: activevatsdata = [] } = useActiveVats();
  const { data: feeearnerdata } = useActiveFeeEarner();

  const AmountNameHeader = (props) => {
    return (
      <div style={{ textAlign: "center", marginBottom: "8px" }}>
        {props.title}
      </div>
    );
  };

  const onChangenominal = (event) => {
    setnominal(event.value);
  };

  const onChangevat = (event) => {
    setvatvalue(event.value);
  };

  const filterData = (filter) => {
    const datas = activevatsdata.slice();
    return filterBy(datas, filter);
  };

  const filterChange = (event) => {
    setvatsData(filterData(event.filter));
  };

  const filternominalData = (filter) => {
    const data = nominallist.slice();
    return filterBy(data, filter);
  };

  const filternominal = (event) => {
    setnominaldata(filternominalData(event.filter));
  };

  const nominallist = useSelector((state) => {
    let array = [];
    let list = state.nominalList.activenominals.data.map((item) => {
      if (item.subType === "ProfitAndLoss_Income") {
        const templist = item;
        templist.representation = item.nominalRef + "  -  " + item.nominalName;
        array.push(item);
        return templist;
      }
    });
    return array;
  });

  const getNominals = async () => {
    const { data } = await api.getactivenominals();
    let array = [];
    data.data.map((item) => {
      if (item.subType === "ProfitAndLoss_Income") {
        const templist = item;
        templist.representation = item.nominalRef + "  -  " + item.nominalName;
        array.push(item);
        return templist;
      }
    });
    return array;
  };

  const handleSubmit = (values) => {
    setShowValidation(true);
    
    if (!vatvalue || !nominal?.nominalRef || !values.feeEarner) {
      setError(true);
      return;
    }

    let dataToPost = [];
    data.map((item) => {
      if (item.add === true) {
        dataToPost.push(item);
      }
    });
    if (dataToPost.length === 0) {
      setError1(true);
      return;
    }

    props.changeMatterList(dataToPost);
    props.addNominalVatInfo({
      nominalRef: nominal,
      vatCode: vatvalue,
      feeEarnerRef: values.feeEarner.userRef,
    });

    props.cancelEdit();
  };

  const itemChange = (e) => {
    let newData = data.map((item) => {
      if (item.timeId === e.dataItem.timeId) {
        item.add = e.value;
      }
      return item;
    });
    setData(newData);
  };

  const addDefaultValues = () => {
    setvatvalue(
      activevatsdata.find(
        (item) => item.vatCodeId == props.defaultValues?.defaultVatCodeId
      )
    );
  };

  const fetchNominal = async () => {
    const data = await getNominals();
    setnominaldata(data?.slice());
    setnominal(
      data?.find(
        (item) => item.nominalRef == props.defaultValues?.defaultProfitNominal
      )
    );
  };

  const getMatterTimeRecordsData = async () => {
    try {
      const response = await api.getMatterTimeRecords(props.matterId);
      setMatters(
        response.data?.data?.map((record) => ({
          inEdit: true,
          type: "Time",
          billVat: 0,
          add: false,
          ...record,
        }))
      );
    } catch (error) {
      console.error("Error fetching matter time records:", error);
      setMatters([]);
    }
  };

  useEffect(() => {
    getMatterTimeRecordsData();
  }, [props.matterId]);

  const SelectionHeaderCell = (props) => {
    return (
      <div className="gap-2 mb-2 d-flex">
        <span>{props.title}</span>
        <Checkbox
          style={{
            width: "18px",
            height: "18px",
            boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
          }}
          onChange={(e) => {
            if (e.value) {
              setData((prevData) =>
                prevData.map((item) => ({ ...item, add: true }))
              );
            } else {
              setData((prevData) =>
                prevData.map((item) => ({ ...item, add: false }))
              );
            }
          }}
          name="isCounselFee"
          value={data.filter((item) => !item.add).length === 0}
        />
      </div>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      setvatsData(activevatsdata.slice());
      addDefaultValues();
    }, 100);
  }, []);

  useEffect(() => {
    fetchNominal();
  }, []);


  const requiredValidator = (value) => {
    return value ? undefined : "invalid"; // triggers k-invalid class for Fee Earner field
  };

  useEffect(() => {
    setTimeout(() => {
      if (
        matters[0] !== null &&
        matters[0] !== "LIST_EMPTY" &&
        matters[0] !== undefined &&
        dataAvailable === false
      ) {
        setData(matters);
        setDataAvailable(true);
      } else if (matters[0] === "LIST_EMPTY") {
        setData([]);
        setDataAvailable(false);
      }
    }, 0);
  }, [matters]);

  return (
    <Dialog title={`Time Record`} onClose={props.cancelEdit} width={"1100px"}>
      <>
        <div className="d-flex flex-column pt-4 pb-3 px-5">
          <div className="d-flex flex-wrap align-items-center validation">
            <Form
              ignoreModified={true}
              onSubmit={handleSubmit}
              id="timeRecord"
              // initialValues={initialData}
              // key={JSON.stringify(initialData)}
              render={(formRenderProps) => {
                return (
                  <div>
                    <FormElement id="timeRecord" name="timeRecord">
                      <fieldset>
                        {formRenderProps.visited &&
                          formRenderProps.errors &&
                          formRenderProps.errors.VALIDATION_SUMMARY && (
                            <div className={"k-messagebox k-messagebox-error"}>
                              {formRenderProps.errors.VALIDATION_SUMMARY}
                            </div>
                          )}

                        <div className="d-flex">
                          <ValidatedComboBox
                            label="Vat Code"
                            value={vatvalue}
                            showValidation={showValidation}
                            name="vatCode"
                            data={activevatsdata}
                            textField="display"
                            filterable={true}
                            onFilterChange={filterChange}
                            iconClassName="wa"
                            onChange={onChangevat}
                            placeholder="Search VAT Code"
                          />

                          <ValidatedComboBox
                            label="Nominal Ref"
                            value={nominal}
                            showValidation={showValidation}
                            name="nominalRef"
                            data={nominaldata}
                            iconClassName="wa"
                            textField="representation"
                            filterable={true}
                            onFilterChange={filternominal}
                            onChange={onChangenominal}
                            placeholder="Search Nominal Ref"
                          />

                          <div className="mb-3">
                            <Field
                              name="feeEarner"
                              component={SearchComboBox}
                              cbType={CONSTANT.FE}
                              validator={requiredValidator}
                              validationMessage=""
                              className="mt-1"
                              iconClassName="wa"
                              width="300px"
                              placeholder="Search Fee Earner Ref"
                              defaultValues={props.defaultValues}
                              defaultValueSetter={formRenderProps}
                            />
                          </div>
                        </div>
                      </fieldset>
                    </FormElement>
                  </div>
                );
              }}
            />
          </div>

          <Grid
            data={data}
            dataItemKey={"timeId"}
            onItemChange={itemChange}
            editField="inEdit"
            className="grid-header-sm mt-2"
            style={{ height: "370px", overflow: "auto" }}
            selectable={{
              enabled: true,
              drag: false,
              cell: false,
              mode: "multiple",
            }}
          >
            <Column
              field="date"
              title="Date"
              editable={false}
              cell={DateFormatCell}
              headerClassName="ps-4"
            />
            <Column
              field="details"
              title="Details"
              editable={false}
              width={"300"}
              cell={NameTextCell}
            />
            <Column field="units" title="Units" editable={false} />
            <Column
              field="value"
              title="Value"
              editable={false}
              cell={AmountFormatCell}
              headerCell={AmountNameHeader}
            />
            <Column
              field="value"
              title="Bill Net"
              editable={false}
              cell={AmountFormatCell}
              headerCell={AmountNameHeader}
            />
            <Column
              field="billVat"
              title="Bill Vat"
              editable={false}
              cell={AmountFormatCell}
              headerCell={AmountNameHeader}
            />
            <Column
              field="add"
              title="Select"
              className="d-flex align-items-center justify-center mt-2 ms-3"
              editor="boolean"
              width={"90px"}
              // headerSelectionValue={true}
              headerCell={SelectionHeaderCell}
            />
          </Grid>

          {error === true && (
            <i style={{ color: "red" }}>Please fill in all required fields</i>
          )}
          {error1 === true && (
            <i style={{ color: "red" }}>Select atleast 1 Record</i>
          )}
        </div>

        <div className="dialog-footer">
          <button
            className="common-btn bgBtnSecondary border-0 me-3"
            onClick={() => {
              props.cancelEdit();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="timeRecord"
            className="k-button common-btn me-4"
          >
            Select
          </button>
        </div>
      </>
    </Dialog>
  );
};

export default MattersTimeRecords;
